// extracted by css-extract-rspack-plugin
export default {"container":"container-ms74HQ"};